import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule }    from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { QuotationComponent } from './members/quotation/quotation.component';
import { HttpClientModule } from '@angular/common/http';
import { MembersComponent } from './members/members.component';
import { CompaniesComponent } from './members/companies/companies.component';
import { UsersComponent } from './members/users/users.component';
import { DashboardComponent } from './members/dashboard/dashboard.component';
import { ContractsComponent } from './members/contracts/contracts.component';
import { CompanyDetailsComponent } from './members/companies/company-details/company-details.component';
import { AddCompanyComponent } from './members/companies/add-company/add-company.component';
import { AddUsersComponent } from './members/users/add-users/add-users.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { EditUsersComponent } from './members/users/edit-users/edit-users.component';
import { NewPasswordComponent } from './members/new-password/new-password.component';
import { AddBranchesComponent } from './members/companies/company-details/add-branches/add-branches.component';
import { EditBranchComponent } from './members/companies/company-details/edit-branch/edit-branch.component';
import { EditCompanyComponent } from './members/companies/company-details/edit-company/edit-company.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CreateContractComponent } from './members/create-contract/create-contract.component';
import { ContractDetailsComponent } from './members/contracts/contract-details/contract-details.component';
import { PasswordCheckComponent } from './password-check/password-check.component';
import { RemoveCompanyComponent } from './members/companies/company-details/remove-company/remove-company.component';
import { RemoveBranchComponent } from './members/companies/company-details/remove-branch/remove-branch.component';
import { CancelContractComponent } from './members/contracts/contract-details/cancel-contract/cancel-contract.component';

import { ExcelService } from './_services/excel.service';
import { DataTablesModule } from "angular-datatables";
import { BrMaskerModule } from 'br-mask';
import { DatePipe } from '@angular/common';
import { ForgotPasswordComponent } from './members/forgot-password/forgot-password.component';
import { PaymentsComponent } from './members/payments/payments.component';
import { EditPaymentComponent } from './members/payments/edit-payment/edit-payment.component';
import { DeleteContractComponent } from './members/contracts/contract-details/delete-contract/delete-contract.component';
import { PaidContractComponent } from './members/contracts/contract-details/paid-contract/paid-contract.component';
import { LoansDasboardComponent } from './members/loans/loans-dasboard/loans-dasboard.component';
import { LoansQuotationComponent } from './members/loans/loans-quotation/loans-quotation.component';
import { LoansContractComponent } from './members/loans/loans-contract/loans-contract.component';
import { LoansPaymentsComponent } from './members/loans/loans-payments/loans-payments.component';
import { LoansCreateContractComponent } from './members/loans/loans-create-contract/loans-create-contract.component';
import { LoansContractDetailsComponent } from './members/loans/loans-contract-details/loans-contract-details.component';
import { SelectCompanyComponent } from './members/form-comp/select-company/select-company.component';
import { SelectProducerComponent } from './members/form-comp/select-producer/select-producer.component';
import { AddressComponent } from './members/form-comp/address/address.component';
import { EmployerInfoComponent } from './members/form-comp/employer-info/employer-info.component';
import { ReferencesComponent } from './members/form-comp/references/references.component';
import { AssetsComponent } from './members/form-comp/assets/assets.component';
import { ApplicantComponent } from './members/form-comp/applicant/applicant.component';
import { CosignerComponent } from './members/form-comp/cosigner/cosigner.component';
import { CollateralsComponent } from './members/form-comp/collaterals/collaterals.component';
import { GuarantorComponent } from './members/form-comp/guarantor/guarantor.component';
import { AmortizationTableComponent } from './members/form-comp/amortization-table/amortization-table.component';
import { PaymentBookComponent } from './members/loans/payment-book/payment-book.component';
import { DeleteLoanContractComponent } from './members/loans/loans-contract-details/delete-loan-contract/delete-loan-contract.component';
import { CancelLoanContractComponent } from './members/loans/loans-contract-details/cancel-loan-contract/cancel-loan-contract.component';
import { PaidLoanContractComponent } from './members/loans/loans-contract-details/paid-loan-contract/paid-loan-contract.component';
import { CierreDocComponent } from './members/loans/cierre-doc/cierre-doc.component';
import { MultiPoliciesComponent } from './members/form-comp/multi-policies/multi-policies.component';
import { PayBookComponent } from './members/pay-book/pay-book.component';
import { CompletedContractComponent } from './members/contracts/contract-details/completed-contract/completed-contract.component';
import { CompletedLoanComponent } from './members/loans/loans-contract-details/completed-loan/completed-loan.component';
import { LoanRequestFormComponent } from './loan-request-form/loan-request-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    QuotationComponent,
    MembersComponent,
    CompaniesComponent,
    UsersComponent,
    DashboardComponent,
    ContractsComponent,
    CompanyDetailsComponent,
    AddCompanyComponent,
    AddUsersComponent,
    EditUsersComponent,
    NewPasswordComponent,
    AddBranchesComponent,
    EditBranchComponent,
    EditCompanyComponent,
    CreateContractComponent,
    ContractDetailsComponent,
    PasswordCheckComponent,
    RemoveCompanyComponent,
    RemoveBranchComponent,
    CancelContractComponent,
    ForgotPasswordComponent,
    PaymentsComponent,
    EditPaymentComponent,
    DeleteContractComponent,
    PaidContractComponent,
    LoansDasboardComponent,
    LoansQuotationComponent,
    LoansContractComponent,
    LoansPaymentsComponent,
    LoansCreateContractComponent,
    LoansContractDetailsComponent,
    SelectCompanyComponent,
    SelectProducerComponent,
    AddressComponent,
    EmployerInfoComponent,
    ReferencesComponent,
    AssetsComponent,
    ApplicantComponent,
    CosignerComponent,
    CollateralsComponent,
    GuarantorComponent,
    AmortizationTableComponent,
    PaymentBookComponent,
    DeleteLoanContractComponent,
    CancelLoanContractComponent,
    PaidLoanContractComponent,
    CierreDocComponent,
    MultiPoliciesComponent,
    PayBookComponent,
    CompletedContractComponent,
    CompletedLoanComponent,
    LoanRequestFormComponent,
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    DataTablesModule,
    BrMaskerModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    BrowserAnimationsModule
  ],
  exports:[
    DataTablesModule
  ],
  providers: [
    ExcelService,
    DatePipe,
    PaymentsComponent,
    ContractDetailsComponent,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
